import { createFileRoute } from '@tanstack/react-router'
import { INVESTOR_NAV_LABEL } from '@workspace/seedforge-ui/lib/investor-nav'
import { AssistantGate } from '../../../../features/investor-assistant/components/assistant-gate'
import { StartupPage } from '../../../../features/investor-assistant/components/relationship/startup-page'

export const Route = createFileRoute('/app/investor/$id/startup/$token')({
  component: StartupRoute,
  validateSearch: (search: Record<string, unknown>): { from?: 'search' } =>
    search.from === 'search' ? { from: 'search' } : {},
})

function StartupRoute() {
  const { token } = Route.useParams()
  const { from } = Route.useSearch()
  return (
    <AssistantGate
      activeNav={from === 'search' ? INVESTOR_NAV_LABEL.search : INVESTOR_NAV_LABEL.following}
    >
      <StartupPage token={token} from={from} />
    </AssistantGate>
  )
}
